export const operators = [
    '>',
    '>=',
    '<',
    '<=',
    '=',
    '!=',
    'contains',
    'does not contain',
    'starts with',
    'ends with',
    'before',
    'after',
]

export const keywords = ['over the last', 'over the lifetime']

export const properties = [
    'state',
    'delivery status',

    'last bid change',
    'last budget change',

    'target acos',
    'bid strategy',
    'bid',
    'default bid',
    'budget',
    'daily budget',

    'campaign name',
    'ad group name',

    'campaign start date',
    'campaign end date',

    'match type',
    'match_type',
    'matchtype',
    'keyword',
    'negated',
    'search term',
    'search_term',

    'min_bid',
    'max_bid',

    'tos_placement',
    'ros_placement',
    'hp_placement',
    'pp_placement',

    'bid_adjustments.top_of_search',
    'bid_adjustments.rest_of_search',
    'bid_adjustments.product_page',
]

export const metrics = [
    'acos',
    'clicks',
    'impressions',
    'orders',
    'sales',
    'roas',
    'ctr',
    'cvr',
    'spend',
    'pages read',
    'estimated royalties',

    'cpc',
    'rpc',
    'cac',
    'aov',
]

export const kdpMetrics = [
    'adjusted sales',
    'blended profit',
    'blended rpc',
    'blended acos',
    'adjusted orders',
    'blended cvr',
    'adjusted pages read',
    'adjusted estimated royalties',
    'blended roas',
    'blended cac',
    'blended aov',
]
